const AppConfig = {
    appId: 'f6b16c23',
    appKey: 'f0bc4f65f4fbfe7b4b3b7264b655f5eb'
};

angular
    .module('BB')
    .value('AppConfig', AppConfig);





// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_constants/app_config.value.js